import { createAction, props } from '@ngrx/store';
import { UploadActionProps } from '../../guards/resolver.helper';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { MultipleGabeImportJobsEntity } from '../../entities/multiple-gabe-import-jobs.entity';


const prefix = 'data/' + 'multipleGabeImportJobs/';
export const MultipleGabeImportJobsActionTypes = {
    Load: createAction(prefix + 'load', props< UploadActionProps >()),
    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<MultipleGabeImportJobsEntity>; updateLatestUpdatedAt?: boolean, }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<MultipleGabeImportJobsEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: MultipleGabeImportJobsEntity }>()),

};
